import React from "react";
import { IconInfo } from "../../../icons";

function getHighlightKey(item, index) {
  if (item && typeof item === "object") {
    return [item.number, item.label, item.text, index].filter(Boolean).join("-");
  }

  return item;
}

function NiceToKnowHighlight({ item }) {
  if (item && typeof item === "object") {
    return (
      <div className="ds-docs-nice-to-know__highlight ds-docs-nice-to-know__highlight--structured">
        <div className="ds-docs-nice-to-know__highlight-number">{item.number}</div>
        <div className="ds-docs-nice-to-know__highlight-label">{item.label}</div>
        <div className="ds-docs-nice-to-know__highlight-text">{item.text}</div>
      </div>
    );
  }

  return <div className="ds-docs-nice-to-know__highlight">{item}</div>;
}

export default function DocsNiceToKnow({
  children = null,
  className = "",
  intro = null,
  items = [],
  criticalItems = [],
  highlightTitle = null,
  highlightItems = [],
  remark = null,
  remarkTone = "neutral",
}) {
  if (!children && !intro && !items.length && !criticalItems.length && !highlightItems.length && !remark) {
    return null;
  }

  const remarkClasses = [
    "ds-docs-nice-to-know__remark",
    remarkTone === "critical" ? "ds-docs-nice-to-know__remark--critical" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const classes = ["ds-docs-nice-to-know", className].filter(Boolean).join(" ");

  return (
    <aside className={classes} aria-label="Nice to know">
      <div className="ds-docs-nice-to-know__label">
        <IconInfo sx={{ fontSize: 16 }} aria-hidden="true" />
        <span>NICE TO KNOW</span>
      </div>
      {children}
      {intro ? <p className="ds-docs-nice-to-know__intro">{intro}</p> : null}
      {items.length ? (
        <ul className="ds-docs-nice-to-know__list">
          {items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
      {criticalItems.length ? (
        <div className="ds-docs-nice-to-know__critical-list">
          {criticalItems.map((item) => (
            <div key={item} className="ds-docs-nice-to-know__critical-item">
              {item}
            </div>
          ))}
        </div>
      ) : null}
      {highlightItems.length ? (
        <div className="ds-docs-nice-to-know__highlights">
          {highlightTitle ? <div className="ds-docs-nice-to-know__highlights-title">{highlightTitle}</div> : null}
          {highlightItems.map((item, index) => (
            <NiceToKnowHighlight key={getHighlightKey(item, index)} item={item} />
          ))}
        </div>
      ) : null}
      {remark ? (
        <div className={remarkClasses}>
          <div className="ds-docs-nice-to-know__remark-label">Bemerkung</div>
          <div>{remark}</div>
        </div>
      ) : null}
    </aside>
  );
}
